import { COLORS, fontSizes } from '../../constants/constants';
import Text from '../../components/Text';
import ViewItems from '../../components/ViewItems';
import ChooseAccountTypeFunctional from './index.function';
import AuthWrapper from '../../components/AuthWrapper';
import images from '../../constants/images';
import { RowView } from '../../components';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { cn } from '../../utils/utils';
import Language from '../../components/Language';

const ChooseAccountType = () => {
  const { TextWeight, isArabic, getContentKey, navigate, onChooseType } = ChooseAccountTypeFunctional();

  return (
    <AuthWrapper>
      <ViewItems className={`w-full`}>
        <ReactSVG src={icons.back} className={cn('cursor-pointer', isArabic ? 'rotate-180' : '')} onClick={() => navigate(-1)} />

        <RowView className='justify-between items-center'>
          <img src={images.textLogo} width={70} className='mt-10' />
          <Language isLogin />
        </RowView>

        <Text text={getContentKey('choose_account_type')} weight={TextWeight.semiBold} size={fontSizes.h18} className={'mb-5 mt-10'} />

        <RowView
          className={
            'border-2 border-primary-green hover:border-primary transition-all duration-300 ease-in-out rounded-lg p-3 items-center bg-primary-green/60 mb-5 cursor-pointer'
          }
          onClick={() => onChooseType('individual')}
        >
          <img src={images.arab_image} alt='' className='w-12 h-12' />
          <div className='mx-2'>
            <Text text={getContentKey('individual_investor')} size={fontSizes.h16} weight={TextWeight.medium} color={COLORS?.black} />
            <Text text={getContentKey('individual_note')} size={fontSizes.h12} weight={TextWeight.regular} color='text-greyish-green' />
          </div>
        </RowView>

        <RowView
          className={
            'border-2 border-primary-green hover:border-primary transition-all duration-300 ease-in-out rounded-lg p-3 items-center bg-primary-green/60 mb-5 cursor-pointer'
          }
          onClick={() => onChooseType('corporate')}
        >
          <img src={images.arab_image} alt='' className='w-12 h-12' />
          <div className='mx-2'>
            <Text text={getContentKey('corporate_investor')} size={fontSizes.h16} weight={TextWeight.medium} color={COLORS?.black} />
            <Text text={getContentKey('corporate_note')} size={fontSizes.h12} weight={TextWeight.regular} color='text-greyish-green' />
          </div>
        </RowView>
      </ViewItems>
    </AuthWrapper>
  );
};

export default ChooseAccountType;
